export default "__VITE_ASSET__DEVChmBX__"